import qs from 'qs';
import { Toast } from 'vant';

export function receiveCoupon(params) {
  const {
    baseURL = `${window.location.origin}${process.env.VUE_APP_H5_BASE}`,
    url,
    uid,
    coupon_id,
    series_id,
    series_name,
    city_id,
    location_amap,
    location_province,
    location_city,
    channel = `ACTIVITIS_${process.env.VUE_APP_H5_KEY}`,
    ...othderParams
  } = params;
  // 主库领券参数
  const pangkuParams = {
    uid,
    coupon_id,
    serial_id: series_id,
    city_id,
    channel,
    format: 'js',
  };
  // 活动领券参数，优惠券id和标题会自动带上
  const activityParams = {
    series_id,
    series_name,
    location_amap,
    location_province,
    location_city,
    ...othderParams,
  };
  // 活动链接
  const activityURL = url ? `${baseURL}${url}` : `${baseURL}/activities/${process.env.VUE_APP_H5_KEY}/coupon/client`;
  const activitySearch = `?${qs.stringify(activityParams)}`;
  const callback = `${activityURL}${activitySearch}`;
  // 主库链接
  const pangkuURL = `${process.env.VUE_APP_PANGKU_MERCHANT}/client/getcoupon`;
  const pangkuSearch = `?${qs.stringify(pangkuParams)}&callback=${encodeURIComponent(callback)}`;
  let jumpURL = `${pangkuURL}${pangkuSearch}`;
  if (process.env.VUE_APP_ENV !== 'production') {
    console.log(jumpURL);
  }
  return new Promise((resolve, reject) => {
    if (process.env.VUE_APP_ENV !== 'development') {
      const handleResume = () => {
        ap.offResume(handleResume);
        const res = JSON.parse(localStorage.getItem('couponInfo'));
        localStorage.removeItem('couponInfo');
        if (res) {
          if (res.success === true) {
            resolve(res);
          } else {
            Toast(res.error_msg || 'Error');
            reject(res);
          }
        } else {
          reject({});
        }
      };
      ap.onResume(handleResume);
      const couponScript = document.createElement('script');
      couponScript.src = jumpURL;
      couponScript.onload = () => {
        ap.pushWindow(window.couponJumpUrl);
      };
      document.body.appendChild(couponScript);
    } else {
      resolve({ success: true });
    }
  });
}

export function receivePayCoupon(params) {
  const {
    baseURL = `${window.location.origin}${process.env.VUE_APP_H5_BASE}`,
    url,
    coupon_id,
    series_id,
    series_name,
    city_id,
    location_amap,
    location_province,
    location_city,
    channel = `ACTIVITIS_${process.env.VUE_APP_H5_KEY}`,
    ...othderParams
  } = params;
  // 主库领券参数
  const pangkuParams = {
    coupon_id,
    serial_id: series_id,
    city_id,
    channel,
  };
  // 活动领券参数，优惠券id和标题会自动带上
  const activityParams = {
    series_id,
    series_name,
    location_amap,
    location_province,
    location_city,
    ...othderParams,
  };
  // 活动链接
  const activityURL = url ? `${baseURL}${url}` : `${baseURL}//activities/${process.env.VUE_APP_H5_KEY}/coupon/client`;
  const activitySearch = `?${qs.stringify(activityParams)}`;
  const callback = `${activityURL}${activitySearch}`;
  // 主库链接
  const pangkuURL = `${window.location.origin}/dist/pay210205/index`;
  const pangkuSearch = `?${qs.stringify(pangkuParams)}&callback=${encodeURIComponent(callback)}`;
  let jumpURL = `${pangkuURL}${pangkuSearch}`;
  if (process.env.VUE_APP_ENV !== 'production') {
    console.log(jumpURL);
  }
  return new Promise((resolve, reject) => {
    if (process.env.VUE_APP_ENV !== 'development') {
      const handleResume = () => {
        ap.offResume(handleResume);
        const res = JSON.parse(localStorage.getItem('couponInfo'));
        localStorage.removeItem('couponInfo');
        if (res) {
          if (res.success === true) {
            resolve(res);
          } else {
            Toast(res.error_msg || 'Error');
            reject(res);
          }
        } else {
          reject({});
        }
      };
      ap.onResume(handleResume);
      ap.pushWindow(jumpURL);
    } else {
      resolve({ success: true });
    }
  });
}
